import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SelectPageService {

  private selectedPageId: string | null = null;

  get getSelectedPageId(): string | null {
    return this.selectedPageId;
  }

  public setSelectedPageId(selectedPageId: string | null) {
    this.selectedPageId = selectedPageId;
  }
}
